<template>
  <div v-if="editMode">
    <div class="fields-row">
      <div class="field-set">
        <label style="margin-bottom: 0;">Rows</label>
        <input type="number" v-model="field.textRows" class="form-control" required min="1" max="20" style="width:80px;" placeholder="Rows" />
      </div>

      <div class="field-set">
        <label style="margin-bottom: 0;">Min Characters</label>
        <input type="number" v-model="field.min" class="form-control" min="1" max="2000" style="width:80px;" placeholder="Min" />
      </div>

      <div class="field-set">
        <label style="margin-bottom: 0;">Max Characters</label>
        <input type="number" v-model="field.max" class="form-control" min="1" max="2000" style="width:80px;" placeholder="Max" />
      </div>
    </div>

    <div class="field-row text-right">
      <div class="checkbox">
        <label>
          <input type="checkbox" v-model="field.required" /> Required
        </label>
      </div>
    </div>
  </div>
  
  <div v-else>
    <div class="vf-field-label">{{ fieldName }}</div>
  </div>
</template>

<script>
  export default {
    name: 'TextField',
    props: {
      field: {
        type: Object,
        required: true,
      },
      editMode: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        // Add your component data here
      };
    },
    methods: {
      // Add your component methods here
    },
  };
</script>

<style scoped>
  
</style>